// autogenerated
import {AthenaeumConstants, ServiceProvider, FileModel} from "@reapptor-apps/reapptor-toolkit";

export default class ImportFixedPricesRequest {

    public file: FileModel | null = null;

    public overrideExisting: boolean = false;

    public boatPriceId: string = "";

    public readonly isImportFixedPricesRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ImportFixedPricesRequest) || ((from as any).isImportFixedPricesRequest === true));
    }

    public static as(from?: object | null): ImportFixedPricesRequest | null {
        return (ImportFixedPricesRequest.is(from)) ? from as ImportFixedPricesRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ImportFixedPricesRequest, "ImportFixedPricesRequest");